export default __webpack_public_path__ + "static/media/express-scripts-logo.add6de9b.png";